import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const alertFn = /* @__PURE__ */ createRecipe('Alert', {
  "variant": "solid",
  "palette": "default"
}, [
  {
    "variant": "gradient",
    "palette": "default",
    "css": {
      "&[data-part=\"root\"]": {
        "bgGradient": "neutral.linear"
      }
    }
  },
  {
    "variant": "gradient",
    "palette": "success",
    "css": {
      "&[data-part=\"root\"]": {
        "bgGradient": "success.linear"
      }
    }
  },
  {
    "variant": "gradient",
    "palette": "warning",
    "css": {
      "&[data-part=\"root\"]": {
        "bgGradient": "warning.linear"
      }
    }
  },
  {
    "variant": "gradient",
    "palette": "danger",
    "css": {
      "&[data-part=\"root\"]": {
        "bgGradient": "danger.linear"
      }
    }
  },
  {
    "variant": "gradient",
    "palette": "info",
    "css": {
      "&[data-part=\"root\"]": {
        "bgGradient": "info.linear"
      }
    }
  }
])

const alertVariantMap = {
  "isInline": [
    "true"
  ],
  "palette": [
    "default",
    "success",
    "danger",
    "warning",
    "info"
  ],
  "variant": [
    "solid",
    "gradient"
  ]
}

const alertVariantKeys = Object.keys(alertVariantMap)

export const alert = /* @__PURE__ */ Object.assign(memo(alertFn.recipeFn), {
  __recipe__: true,
  __name__: 'alert',
  __getCompoundVariantCss__: alertFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: alertVariantKeys,
  variantMap: alertVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, alertVariantKeys)
  },
  getVariantProps: alertFn.getVariantProps,
})